import axios from 'axios';
import baseService from '../shared/baseService';

const originService = () => baseService('origins');

const getAllByClientId = (clientId: number) => axios.get(`origins?clientId=${clientId}`);

export default { 
    originService,
    getAllByClientId
};
